module.exports = __webpack_public_path__ + "static/media/people.669db4cc.png";